import { createEnvelopeSource } from './create-envelope-source';

/**
 * Feature-active users (`GET /analytics/feature-active-users`). A ratio, not a
 * count: of the users who signed up in the period, the share who have ever
 * activated a promotion or used the carwash.
 *
 * `rate` only: the `number` form renders a ratio as its raw `rate`, so a share
 * reads `0.234` where `23.4%` is meant. That path serves average ratios like
 * `sessionsPerUser`, and no type distinguishes an average from a share.
 */
export const featureActiveUsersSource = createEnvelopeSource({
    label: 'Feature-active users',
    endpoint: 'analytics/feature-active-users',
    metrics: [
        {
            id: 'featureActiveUsers',
            label: 'Feature-active users',
            type: 'ratio',
        },
    ],
    forms: ['rate'],
    regionGrain: 'province',
});
